import logo from './logo.svg';
import './App.css';
import React from 'react';
import {render} from "react-dom";

import Navbar from './components/Navbar';
import SideNabar from './components/SideNavbar';

import LogoSection from "./components/LogoSection";
import TopNavbar from './components/TopNavbar';
import Accounts from './components/Accounts';
import Contacts from './components/Contacts/Contacts';
import Interaction from './components/Interaction';
import CruiseControl from './components/CruiseControl/CruiseControl';
import CruiseControlSetUp from './components/CruiseControl/CruiseControlSetUp';

import Analytics from './components/Analytics';

import Reports from './components/Reports'

import Authentication from './components/Authentication';
import useToken from './components/useToken';


import { BrowserRouter, Routes,  Route, Link } from 'react-router-dom';


function App() {

const token = useToken();



 
  if (token==""){
    return (
      <BrowserRouter>
        <main>
          
            <div className="login-container">
                <div className='login-header'>Account Login</div>
                <div className="login-section">
                    <Routes>
                      <Route  path="/" element={<> <Authentication /></>} />
                      <Route  path="/login" element={<> <Authentication /></>} />
                    </Routes>
                </div>
                <div className='login-footer'>&copy; 2022 Sales Hustl!</div>
            </div>
          
        </main>
      </BrowserRouter>
    );
  }

  return (
    
    <BrowserRouter>
      <div class="flex  flex-wrap h-screen">
        <div class="h-14 logoSection w-1/6"><LogoSection/></div>
        <div class="h-14 w-5/6"><TopNavbar /></div>

        <div class="sideNavBar"><SideNabar /></div>
        <div class="w-5/6 bg-slate-100">
          <main>
            <Routes>
              <Route  exact path="/" element={<> </>} />
              <Route  path="/accounts" element={<><Accounts /> </>} />
              <Route  path="/contacts/:id" element={<><Contacts /> </>} />
              <Route  path="/contacts/" element={<><Contacts /> </>} />
              <Route  path="/cruisecontrol/" element={<><CruiseControlSetUp /> </>} />
              <Route  path="/interaction/:id" element={<><Interaction /> </>} />
              <Route  path="/analytics/" element={<><Analytics /> </>} />
              <Route  path="/login" element={<><Authentication /> </>} />
            </Routes>
          </main>
        </div>
        
      </div>
    </BrowserRouter>
    
  );
}

export default App;
